import { Retailer_Network_Performance_Period } from '@occc/graphql';

export const performancePeriodOptions: {
  label: string;
  value: Retailer_Network_Performance_Period;
}[] = [
  {
    label: 'This Month',
    value: Retailer_Network_Performance_Period.ThisMonth,
  },
  {
    label: 'Last Month',
    value: Retailer_Network_Performance_Period.LastMonth,
  },
  {
    label: 'Last 7 Days',
    value: Retailer_Network_Performance_Period.Last_7Days,
  },
  {
    label: 'Last 30 Days',
    value: Retailer_Network_Performance_Period.Last_30Days,
  },
  {
    label: 'Last 90 Days',
    value: Retailer_Network_Performance_Period.Last_90Days,
  },
];

export const mapPeriodValueToPeriodType: { [key: string]: Retailer_Network_Performance_Period } = {
  [Retailer_Network_Performance_Period.ThisMonth]: Retailer_Network_Performance_Period.ThisMonth,
  [Retailer_Network_Performance_Period.LastMonth]: Retailer_Network_Performance_Period.LastMonth,
  [Retailer_Network_Performance_Period.Last_7Days]: Retailer_Network_Performance_Period.Last_7Days,
  [Retailer_Network_Performance_Period.Last_30Days]:
    Retailer_Network_Performance_Period.Last_30Days,
  [Retailer_Network_Performance_Period.Last_90Days]:
    Retailer_Network_Performance_Period.Last_90Days,
};
